import { Button } from '@/components/molecules/buttons/button';
import React from 'react';
import { getEmojiFlag } from 'countries-list'
import { useNavigate } from 'react-router-dom';
import {
    ContextMenu,
    ContextMenuContent,
    ContextMenuItem,
    ContextMenuTrigger,
} from "@/components/ui/context-menu";
import { useDeleteProspectCv } from '@/services/mutation/useDeleteProspectCv';
import DeleteIcon from '@mui/icons-material/Delete';
import { Label } from '@/components/atoms/texts/label';


export default function SaveTemplate({ data,refetch, onDelete, ...props }) {
    const navigate = useNavigate();
    const { deleteProspectCv, loading } = useDeleteProspectCv();

    const handleDelete = async (e) => {
        e.stopPropagation();
        try {
            await deleteProspectCv(data.uuid);
            if (onDelete) {
                onDelete(data.uuid);
            }
        } catch (error) {
            console.error('Failed to delete template:', error);
        }
    };

    return (
        <ContextMenu>
            <ContextMenuTrigger asChild>
                <Button
                    style="ghost"
                    showLeftIcon
                    leftIcon={getEmojiFlag(data.language == "EN" ? "GB" : data.language)}
                    onClick={() => {navigate(`generate/${data.uuid}`)}}
                    {...props}
                    className="justify-start">
                    {data.templateTitle || data.title.title}
                </Button>
            </ContextMenuTrigger>
            <ContextMenuContent className="max-w-400px">
                <ContextMenuItem 
                    onClick={handleDelete}
                    disabled={loading}
                    className="text-red-600 focus:text-red-600 gap-betweenText flex  "
                >
                    <DeleteIcon className="mr-2 h-4 w-4" />
                    <Label message="global.actions.delete" />
                    <Label>{data.templateTitle || data.title.title}</Label>
                </ContextMenuItem>
            </ContextMenuContent>
        </ContextMenu>
    )
}